// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RGbFPavlhzMAS7 {
  min-width: 115px;
  margin: 4px 0 2px 8px;
  padding: 7px 9px;
}
.RGbFPavlhzMAS7 > span {
  color: var(--ds-icon, #44546f);
}
.OfV8ekfHPhB8cA {
  display: block;
  margin: 0 -12px;
  padding: 6px 12px;
  color: var(--ds-text, #172b4d);
}
.OfV8ekfHPhB8cA:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.KB8JF6QLLBHz3q {
  margin: 0;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
.Yq3h6P8yakoYpW {
  margin-top: 4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"removeMemberFromWorkspaceButton": `RGbFPavlhzMAS7`,
	"removeMemberFromWorkspacePopoverContent": `OfV8ekfHPhB8cA`,
	"removeMemberFromWorkspaceDescription": `KB8JF6QLLBHz3q`,
	"removeMemberCheckbox": `Yq3h6P8yakoYpW`
};
export default ___CSS_LOADER_EXPORT___;
